import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'searchText'})
export class SearchTextPipe implements PipeTransform {
    transform(arr: any[], txt: string): any {
        const res = arr.filter(item => {
            if (!txt) txt = ""
            let str = item.toLowerCase()
            const idx = str.indexOf(txt.toLowerCase())
            return (idx !== -1)
        })
        return res
    }
}